import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EstatusPostulacionType } from 'src/app/enums/EstatusPostulacionType.enum';
import { RolesType } from 'src/app/enums/RolesType.enum';
import { JwtResponse } from 'src/app/interfaces/jwt';
import { PostulacionEmpresa, PostulacionVacante } from 'src/app/interfaces/postulacion';
import { PostulacionService } from 'src/app/services/postulacion/postulacion.service';
import { environment } from 'src/environments/environment';
import { ModalMessageComponent } from '../../common/modalmessage/modalmessage.component';

@Component({
  selector: 'app-company-list',
  templateUrl: './vacant-and-proyects.component.html',
  styleUrls: ['./vacant-and-proyects.component.scss']
})
export class VacantListComponent implements OnInit {

  usuario: JwtResponse;
  postulaciones: PostulacionVacante[];
  postulacionesEmpresa: PostulacionEmpresa[];
  noPagina: number;
  estatus: string[];
  estatusSeleccionado: string;
  formBus: FormGroup;

  constructor(private title: Title, private meta: Meta, private postulacionService: PostulacionService,
    private modalService: NgbModal, private formBuilder: FormBuilder) {
    this.agregarMetaData();
    this.usuario = JSON.parse(localStorage.getItem('currentUser'));
    this.estatus = [EstatusPostulacionType.PEDIENTE, EstatusPostulacionType.VISTO, EstatusPostulacionType.CERRADA];
    this.estatusSeleccionado = null;
  }

  ngOnInit(): void {
    this.crearFormularioBuscardor();
    this.noPagina = 1;

    if(this.usuario.role === RolesType.CANDIDATOS){
      this.obtenerPostulacionesPorCandidato(this.usuario.user.idUsuario, null);
    }else if(this.usuario.role === RolesType.EMPRESAS){
      this.obtenerPostulacionesPorEmpresa(this.usuario.user.idUsuario, null);
    }
  }

  crearFormularioBuscardor(): void {
    this.formBus = this.formBuilder.group({
      buscador: [null, Validators.required]
    });
  }

  private agregarMetaData(): void {
    this.title.setTitle('Postulaciones');
    this.meta.updateTag({name: "description", content: "Monitorea tus postulaciones a tus vacantes y respuestas de la misma."});//falta descripcion e imagen para mostrar en open graph
    this.meta.updateTag({name: "keywords", content: "postulaciones, vacantes, empleos, datos, perfil"});
    this.meta.updateTag({name: "robots", content: "noodp"});
    this.meta.updateTag({property: "og:title", content: "Postulaciones"});
    this.meta.updateTag({property: "og:description", content: "Monitorea tus postulaciones a tus vacantes y respuestas de la misma."});
    this.meta.updateTag({property: "og:url", content: environment.baseTG});
    this.meta.updateTag({property: "og:site_name", content: "TG Empleos"});
    this.meta.updateTag({property: "og:locale", content: "es_ES"});
    this.meta.updateTag({property: "og:type", content: "website"});
    this.meta.updateTag({property: "og:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
    this.meta.updateTag({name: "twitter:title", content: "Postulaciones"});
    this.meta.updateTag({name: "twitter:description", content:"Monitorea tus postulaciones a tus vacantes y respuestas de la misma."});
    this.meta.updateTag({name: "twitter:site", content: "@tecgurusnet"});
    this.meta.updateTag({name: "twitter:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
    this.meta.updateTag({name: "twitter:creator", content: "@tecgurusnet"});
    this.meta.updateTag({name: "twitter:card", content: "summary"});
  }

  async obtenerPostulacionesPorCandidato(idCandidato: number, buscar: string){
    try {
      const response = await this.postulacionService.obtenerPosutlacionesPorIdCandidato(idCandidato, buscar);
      this.postulaciones = response.data;
    } catch (error) {
      console.error("Error al obtener las postulaciones del candidato", error);
    }
  }

  async obtenerPostulacionesPorEmpresa(idEmpresa: number, buscar: string){
    try {
      const response = await this.postulacionService.obtenerPosutlacionesPorIdEmpresa(idEmpresa, buscar);
      this.postulacionesEmpresa = response.data;
    } catch (error) {
      console.error("Error al obtener las postulaciones del candidato", error);
    }
  }

  actualizarEstatus(idPostulacion: number, estatus: string): void {
    this.postulacionService.actualizarEstatusPostulacion(idPostulacion, estatus).pipe(
      catchError(error => {
        let mensajeError = '';
        if (error.status === 0) {
          mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
          mensajeError += `Http error: ${error.message}`;
          console.error('se ha producido un error:', error.error);
        } else {
          mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
          mensajeError += `Http error: ${error.message}`;
          console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
        }
        this.abrirModalMessage("Error", mensajeError);
        return throwError(mensajeError);
      })
    ).subscribe(result => {
      if (result.success) {
        this.ngOnInit();
        this.abrirModalMessage("Éxito", "Se ha actualizado correctamente el estatus de la vacante.");
      } else {
        this.abrirModalMessage("Error", "No se ha actualizado el estatus del vacante correctamente");
        console.error('Error al actualizar la postulación del vacante de la empresa: ', result.messageError);
      }
    });
  }

  buscarPostulados(): void {
    if(this.usuario.role === RolesType.CANDIDATOS){
      if(this.formBus.get('buscador').value){
        this.obtenerPostulacionesPorCandidato(this.usuario.user.idUsuario, this.formBus.get('buscador').value);
      }else {
        this.obtenerPostulacionesPorCandidato(this.usuario.user.idUsuario, null);
      }
    }

    if(this.usuario.role === RolesType.EMPRESAS){
      if(this.formBus.get('buscador').value){
        this.obtenerPostulacionesPorEmpresa(this.usuario.user.idUsuario, this.formBus.get('buscador').value);
      }else {
        this.obtenerPostulacionesPorEmpresa(this.usuario.user.idUsuario, null);
      }
    }
  }

  scrollToElement($element): void {
    $element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
  }

  abrirModalMessage(modalTitle: string, modalMessage: string) {
    const modalRef = this.modalService.open(ModalMessageComponent, { centered: true });
    modalRef.componentInstance.modalTitle = modalTitle;
    modalRef.componentInstance.modalMessage = modalMessage;
  }
}
